<!-- Shows the certificates avaiable to a given product. Meaning you should be able to view all the certificates issued to you under a given product(crop)-->
<template>
    <div id="loginBox" class="flex justify-center">
		<!--
        <p class="text-center text-grey text-xs">
            ©2019 All rights reserved.
        </p>
			-->
    </div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";

export default {
    name: "LougoutView",
    created() {
        var URL = this.$store.state.urls.USER_LOGOUT;
        var that = this;

        asyncRequest.ServerAPI({
            method: "delete",
            api: URL,
            onSuccessCallback: dataIn => {
                that.$store.commit("userDetails/resetState", {});
                that.$router.push("/", "");
            },
            onFailCallback: function() {},
            flags: asyncRequest.M_FAIL,
            beforeAfterCallback: false
        });
    },
    data() {
        return {};
    },
    methods: {},
    components: {}
};
</script>

<style>
/* We need to do some css to makesure this page is drawn over everything and takes the whole screen space */
#loginBox {
    height: 100%;
    width: 100%;
    background-color: #000;
    position: fixed;
    top: 0;
    z-index: 999;
}
</style>
